<template>
  <div class="home">
    <BackButton @click="goBack" />
    <div class="slider-block">
      <div class="slider" :class="activeMode == 'withdraw' ? 'move-right' : null"></div>
      <p :class="activeMode == 'deposit' ? 'activeBlock' : null" @click="changeActive">{{ $t("deposit") }}</p>
      <p :class="activeMode == 'withdraw' ? 'activeBlock' : null" @click="changeActive">{{ $t("withdraw") }}</p>
    </div>
    <div style="position: relative; width: 100%; overflow-y: hidden; height: 100%">
      <TransitionGroup name="fade">
        <div v-if="activeMode == 'deposit' && isLoading" class="loading-spinner">
          <div class="spinner"></div>
        </div>
        <div class="notificationsList" v-if="activeMode == 'deposit' && !isLoading">
          <div class="notify" @click="$router.push('/finance/deposit/card_rub')">
            <div class="notifyImg">
              <img src="../assets/icons/ru.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>{{ $t("bankCard") }}, <span> RUB</span></p>
              </div>
              <!-- <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div> -->
            </div>
          </div>
          <div class="notify" @click="$router.push('/finance/deposit/sbp_rub')" v-if="isShowQr">
            <div class="notifyImg">
              <img src="../assets/icons/sbp.svg" style="border-radius: 9900px; width: 30px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>{{ $t("sbp") }}, <span> RUB</span></p>
              </div>
              <!-- <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div> -->
            </div>
          </div>
          <!-- <div class="notify" @click="$router.push('/finance/deposit/card_uah')">
            <div class="notifyImg">
              <img src="../assets/icons/ua.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>{{ $t("bankCard") }}, <span> UAH</span></p>
              </div>
              <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div>
            </div>
          </div> -->
          <!-- <div class="notify" @click="$router.push('/finance/deposit/card_kzt')">
            <div class="notifyImg">
              <img src="../assets/icons/kz.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>{{ $t("bankCard") }}, <span> KZT</span></p>
              </div>
              <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div>
            </div>
          </div> -->
          <div class="notify" @click="$router.push('/finance/deposit/usdt')">
            <div class="notifyImg">
              <img src="../assets/icons/tether.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>Tether</p>
              </div>
              <!-- <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div> -->
            </div>
          </div>
          <div class="notify" @click="$router.push('/finance/deposit/btc')">
            <div class="notifyImg">
              <img src="../assets/icons/bitcoin.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>Bitcoin</p>
              </div>
              <!-- <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div> -->
            </div>
          </div>
          <div class="notify" @click="$router.push('/finance/deposit/eth')">
            <div class="notifyImg">
              <img src="../assets/icons/ethereum.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>Ethereum</p>
              </div>
              <!-- <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div> -->
            </div>
          </div>
          <!-- <div class="promoBlock">
            <input type="text" :placeholder="$t('activatePlaceholder')" class="timeInput" v-model="selectedPromocode" />
            <button class="timeAcceptButton" :class="selectedPromocode != '' ? 'active' : ''" @click="activatePromocode">{{ $t("activate") }}</button>
            <p v-if="promoValue" class="promo_value">
              {{ $t("promocode") }} <span>{{ promoValue }}</span> {{ $t("promocodeEnd") }}!
            </p>
          </div> -->
        </div>
        <div class="notificationsList" v-if="activeMode == 'withdraw'">
          <div class="notify" @click="$router.push('/finance/withdraw/card_rub')">
            <div class="notifyImg">
              <img src="../assets/icons/ru.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>{{ $t("bankCard") }}, <span> RUB</span></p>
              </div>
              <!-- <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div> -->
            </div>
          </div>
          <!-- <div class="notify" @click="$router.push('/finance/withdraw/card_uah')">
            <div class="notifyImg">
              <img src="../assets/icons/ua.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>{{ $t("bankCard") }}, <span> UAH</span></p>
              </div>
               <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div>
            </div>
          </div>
           <div class="notify" @click="$router.push('/finance/withdraw/card_kzt')">
            <div class="notifyImg">
              <img src="../assets/icons/kz.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>{{ $t("bankCard") }}, <span> KZT</span></p>
              </div>
              <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div> 
            </div>
          </div> -->
          <div class="notify" @click="$router.push('/finance/withdraw/usdt')">
            <div class="notifyImg">
              <img src="../assets/icons/tether.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>Tether</p>
              </div>
              <!-- <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div> -->
            </div>
          </div>
          <div class="notify" @click="$router.push('/finance/withdraw/btc')">
            <div class="notifyImg">
              <img src="../assets/icons/bitcoin.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>Bitcoin</p>
              </div>
              <!-- <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div> -->
            </div>
          </div>
          <div class="notify" @click="$router.push('/finance/withdraw/eth')">
            <div class="notifyImg">
              <img src="../assets/icons/ethereum.svg" style="border-radius: 9900px" />
            </div>
            <div class="notifyText">
              <div class="notifyHead">
                <p>Ethereum</p>
              </div>
              <!-- <div class="notifySum">
                <p class="notifySumText">от 1 000 ₽</p>
              </div> -->
            </div>
          </div>
        </div>
      </TransitionGroup>
    </div>
    <Transition name="fade">
      <NotifyComponent :timely="false" :duration="3" :notify="notifyText" v-if="isShowNotify" @closeNotify="isShowNotify = false" />
    </Transition>
  </div>
</template>

<script>
import axios from "axios";
import { BackButton } from "vue-tg";
import NotifyComponent from "../components/NotifyComponent.vue";
import { UserManager } from "@/utils/userManager";
export default {
  name: "NotificationsPage",
  data() {
    return {
      activeMode: "deposit",
      selectedPromocode: "",
      isShowNotify: false,
      notifyText: "",
      promoValue: "",
      botId: "",
      user: null,
      isShowQr: false,
      isLoading: false,
    };
  },
  methods: {
    goBack() {
      window.location.href = "/";
    },
    changeActive() {
      if (this.activeMode == "deposit") {
        this.activeMode = "withdraw";
        this.$router.push("/finance/withdraw");
      } else {
        this.activeMode = "deposit";
        this.$router.push("/finance/deposit");
      }
    },
    activatePromocode() {
      this.promoValue = "FsafawFqwf"; // УБРАТЬ
      this.selectedPromocode = ""; // УБРАТЬ
      if (this.selectedPromocode.length == 0) return this.showNotify(this.$t("emptyArea"));
      // Убеждаемся, что bot_id и user есть
      if (!this.botId || !this.user) {
        const userContext = UserManager.getFullUserContext();
        this.botId = userContext.botId;
        this.user = userContext.user;
        this.$store.commit("setBotId", this.botId);
        this.$store.commit("setTgUserData", this.user);
      }
      axios
        .post(`${window.location.origin}/promo/activate`, {
          user_id: this.user.id,
          bot_id: this.botId,
          promo: this.selectedPromocode,
        })
        .then((res) => {
          console.log(res);
          this.showNotify(this.$t("promocodeActivated"));
          this.promoValue = "FsafawFqwf";
          this.selectedPromocode = "";
        })
        .catch((err) => {
          console.log(err);
          this.showNotify(this.$t("promocodeError"));
        });
    },
    showNotify(text) {
      this.notifyText = text;
      this.isShowNotify = true;
    },
    selectDepositMethod() {},
    async isAvailableQR() {
      this.isLoading = true;
      try {
        const res = await axios.get(`${window.location.origin}/user/qr_info/${this.botId}/${this.user.id}`);
        console.log(res);
        this.isShowQr = true;
      } catch (err) {
        console.log(err);
        this.isShowQr = false;
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    const userContext = UserManager.getFullUserContext();
    this.user = userContext.user;
    this.botId = userContext.botId;
    this.$store.commit("setBotId", this.botId);
    this.$store.commit("setTgUserData", this.user);
    this.activeMode = this.$route.params.id;
    this.isAvailableQR();
  },
  components: { BackButton, NotifyComponent },
};
</script>

<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  background-color: var(--background-color);
  height: 100vh;
  max-width: 100vw;
}
.slider-block {
  font-size: 14px;
  display: flex;
  margin: 0 auto;
  background-color: var(--button-background);
  border-radius: 50px;
  position: relative;
  padding: 5px 10px 5px 10px;
}
.slider-block p {
  padding: 5px 20px 5px 20px;
  flex: 1;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  z-index: 1;
  color: #737376;
  cursor: pointer;
  user-select: none;
}
.slider {
  background-color: var(--slider-color);
  width: 50%;
  height: 70%;
  position: absolute;
  left: 3%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 0;
  border-radius: 50px;
  transition: left 0.4s, width 0.5s;
}
.slider.move-right {
  left: 49%;
  width: 49%;
}
.activeBlock {
  color: var(--text-color1) !important;
}
.notify {
  background-color: var(--second-color);
  border-radius: 14px;
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;
  padding: 3%;
  cursor: pointer;
}
.notifyText {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 6px;
}
.notifyHead p span {
  color: #808080;
}
.notifyHead {
  font-size: 17px;
}
.notifyTime {
  font-size: 14px;
  color: #808080;
}
.notifySumText {
  font-size: 15px;
  color: #808080;
}
.notifySumText.success {
  color: #27c12d;
}
.notifySumText.lose {
  color: #ff3535;
}
.notificationsList {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  position: absolute;
  width: 100%;
}
.timeInput {
  width: 100%;
  background-color: var(--button-background);
  border-radius: 10px;
  border: 0;
  padding: 13px;
  font-size: 17px;
  outline: none;
  color: var(--text-color1);
}
.timeAcceptButton {
  background-color: #007aff;
  border-radius: 10px;
  padding: 15px;
  color: var(--button-text-color);
  border: 0;
  font-size: 16px;
  font-family: "SF Pro Text Bold";
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s;
  width: 100%;
}
.timeAcceptButton.active {
  opacity: 1;
}
.promoBlock {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}
.promo_value {
  font-size: 14px;
}
.promo_value span {
  color: rgb(71, 133, 248);
  font-size: 16px;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* или другой размер, в зависимости от вашего дизайна */
}

.spinner {
  border: 4px solid var(--white-to-black); /* Цвет фона */
  border-top: 4px solid var(--text-color1); /* Цвет верхней части */
  border-radius: 50%;
  width: 40px; /* Размер круга */
  height: 40px; /* Размер круга */
  animation: spin 1s linear infinite; /* Анимация вращения */
}
</style>
